module.exports = __webpack_public_path__ + "img/plant_4_mobile_small.c51c4005.webp";